module.exports = __webpack_public_path__ + "static/media/Mime Artist.42c6c43b.jpg";